<div mat-dialog-title class="dialog-title">
  <div class="dialog-title-content">
    <h2>{{ 'INBOX.MESSAGE_TEMPLATES.TITLE' | translate }}</h2>
    <a data-testid="edit-button" mat-stroked-button mat-dialog-close [routerLink]="getEditRoute()">
      {{ 'INBOX.MESSAGE_TEMPLATES.MODAL.EDIT_TEMPLATES' | translate }}
    </a>
  </div>
</div>
<mat-dialog-content class="dialog-content">
  <ng-container *ngIf="templates$ | async as templateList">
    <ng-container *ngIf="(loading$ | async) === false; else loadingTemplates">
      <mat-action-list *ngIf="templateList.length > 0; else emptyState">
        <button mat-list-item *ngFor="let template of templateList" (click)="selectTemplate(template)">
          <span matListItemTitle>{{ template.name }}</span>
          <span matListItemLine>{{ template.content }}</span>
        </button>
      </mat-action-list>
      <glxy-infinite-scroll-trigger
        (isVisible)="loadNext()"
        [visiblilityMargin]="0"
        [minHeight]="0"
      ></glxy-infinite-scroll-trigger>
    </ng-container>
  </ng-container>
</mat-dialog-content>

<ng-template #loadingTemplates>
  <glxy-loading-spinner></glxy-loading-spinner>
</ng-template>
<ng-template #emptyState>
  <glxy-empty-state [size]="'small'">
    <glxy-empty-state-hero>
      <mat-icon>article</mat-icon>
    </glxy-empty-state-hero>
    <glxy-empty-state-title>
      {{ 'INBOX.MESSAGE_TEMPLATES.MODAL.EMPTY_STATE_TITLE' | translate }}
    </glxy-empty-state-title>
    <p>{{ 'INBOX.MESSAGE_TEMPLATES.MODAL.EMPTY_STATE_CONTENT' | translate }}</p>
  </glxy-empty-state>
</ng-template>
